import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { StyledPageHeader } from "./styled";

function PageHeader({
  logoSrc,
  logoAlt = "Brand",
  onBack,
  showBack = true,
  primaryColor,
  className = "",
}) {
  return (
    <StyledPageHeader
      className={`v2-header-wrapper v2-page-header ${className}`.trim()}
      primaryColor={primaryColor}
    >
      {showBack ? (
        <button
          type="button"
          className="page-header-action"
          aria-label="Back"
          onClick={onBack}
        >
          <ArrowBackIcon />
        </button>
      ) : (
        <span />
      )}
      <span className="page-header-logo-wrap">
        <LazyLoadImage
          effect="opacity"
          src={logoSrc}
          alt={logoAlt}
          className="page-header-logo"
        />
      </span>
      <span />
    </StyledPageHeader>
  );
}

export default PageHeader;
